import { tenant as constants } from "store/constants";
import {
	COLUMN_HEADER_KEYS,
	DEFAULT_DATE_FORMAT,
	DEFAULT_DATETIME_FORMAT,
	FIELD_TYPES,
} from "globals/constants";
import { reduceIsFetching, fetchableInitialState } from "store/factories/fetchable";


export const initialState = {
	...fetchableInitialState,
	attachmentTypes: {
		PROPOSAL: [],
	},
	awardStatuses: [],
	budgetBuilderEnabled: false,
	bulkDelete: true,
	bulkLoad: true,
	categories: {
		PROPOSAL: [],
	},
	certificationTexts: {
		AWARDS: {
			text: "",
			updateDate: null,
			updatedByUserId: "",
			updatedByUserFullName: "",
			history: [],
		},
		PROPOSALS: {
			text: "",
			updateDate: null,
			updatedByUserId: "",
			updatedByUserFullName: "",
			history: [],
		},
	},
	customerId: null,
	dateFormat: DEFAULT_DATE_FORMAT,
	datetimeFormat: DEFAULT_DATETIME_FORMAT,
	columnHeaders: [],
	formColumnHeaders: {
		[COLUMN_HEADER_KEYS?.PROPOSAL]: [],
		[COLUMN_HEADER_KEYS?.AWARD]: [],
		[COLUMN_HEADER_KEYS?.SUBAWARD]: [],
		[COLUMN_HEADER_KEYS?.PROJECT]: [],
		[COLUMN_HEADER_KEYS?.BUDGET]: [],
		[COLUMN_HEADER_KEYS?.MODIFICATIONS]: [
			{ keys: [ "formNumber" ], columnHeader: "Modification", slug: `formNumber`, id: "form-number" },
			{ keys: [ "category" ], columnHeader: "Modification Type", slug: "category", id: "modification-type" },
			{ keys: [ "modificationDate" ], columnHeader: "Modification Date", slug: "modificationDate", id: "modified", type: FIELD_TYPES?.DATE },
			{ keys: [ "modifiedByName" ], columnHeader: "Modified By", slug: "modifiedBy", id: "modified-by" },
			{ keys: [ "comment" ], columnHeader: "Comment", slug: "comments", id: "comment" },
		],
		[COLUMN_HEADER_KEYS?.SUBAWARD_MODIFICATIONS]: [
			{ keys: [ "formNumber" ], columnHeader: "Modification", slug: `formNumber`, id: "form-number", disabled: true },
			{ keys: [ "category" ], columnHeader: "Modification Type", slug: "category", id: "modification-type" },
			{ keys: [ "modificationDate" ], columnHeader: "Modification Date", slug: "modificationDate", id: "modified", type: FIELD_TYPES?.DATE },
			{ keys: [ "modifiedByName" ], columnHeader: "Modified By", slug: "modifiedBy", id: "modified-by" },
			{ keys: [ "comment" ], columnHeader: "Comment", slug: "comments", id: "comment" },
		],
	},
	hostname: "",
	infoReadyEnabled: false,
	modificationTypes: {},
	projectAttachmentTypes: [],
	projectStatuses: [],
	proposalStatuses: [],
	resolutions: [],
	simplifiedFormBuilderEnabled: false,
	subawardCostCap: 0,
	tenantId: null,
	timezone: "",
	useFundingSchemeDictionary: false,
};

export function tenant(state = initialState, action) {
	switch (action.type) {
		case constants.TENANT_IS_FETCHING: {
			return reduceIsFetching(state, action);
		}
		case constants.TENANT_SET_DATA: {
			return {
				...state,
				...action.payload,
			};
		}
		case constants.TENANT_SET_ERROR: {
			return {
				...state,
				error: action.payload,
			};
		}
		case constants.SET_CERTIFICATION_TEXT: {
			return {
				...state,
				certificationTexts: {
					...state.certificationTexts,
					[action.payload.formType.toUpperCase()]: action.payload.certificationTextData,
				},
			};
		}
		default:
			return state;
	}
}
